import React from "react";
import { Box, Typography, Chip, Checkbox } from "@tiny/components";
import { SegmentRowProps } from "../AITrafficSegmentDetailsDialog.types";
import { useStyles } from "./SegmentRow.styles";

function SegmentRow({
  segment,
  onClick,
  isLast = false,
  selected = false,
  onToggleSelect,
}: SegmentRowProps) {
  const classes = useStyles({ isLast });

  const handleCheckboxClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onToggleSelect?.(segment.segmentId);
  };

  const handleRowClick = () => {
    onClick();
  };

  return (
    <Box className={classes.container} onClick={handleRowClick}>
      {onToggleSelect && (
        <Box
          className={classes.checkboxContainer}
          onClick={handleCheckboxClick}
        >
          <Checkbox checked={selected} color="primary" />
        </Box>
      )}
      <Box className={classes.contentWrapper}>
        <Box className={classes.segmentDetailsLeft}>
          <Box className={classes.segmentHeader}>
            <Typography
              variant="label1"
              color="primary"
              tone="main"
              noWrap
              component={"div"}
            >
              {segment.segmentName}
            </Typography>
            <Box mt={0.5}>
              {segment?.enabled && (
                <Chip
                  label="Active"
                  size="small"
                  className={classes.activeChip}
                />
              )}
              {segment.priority > 0 && (
                <Typography variant="label3" color="grey" tone={700}>
                  Priority: {segment.priority}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>

        <Box className={classes.audienceCustomers}>
          <Typography
            variant="body2"
            tone={900}
            color="grey"
            fontWeight="semiBold"
          >
            {segment.numberOfCustomers.toLocaleString()}
          </Typography>
          <Typography variant="label3" tone={700} color="grey">
            Customers
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default SegmentRow;
